import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingState, ErrorState, CancelState } from '../../components/ui/StatusStates';
import api from '../../services/api';

const SubscriptionCancel = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      try {
        if (!currentUser) {
          setLoading(false);
          return;
        }

        const response = await api.get('/subscription/status');
        setSubscription(response.data.data.subscription);
      } catch (err) {
        console.error('Error fetching subscription status:', err);
        setError(err.response?.data?.message || 'Error fetching subscription status');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionStatus();
  }, [currentUser]);

  return (
      <Container fluid className="py-5">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="shadow-sm">
              <Card.Header className="bg-light text-center">
                <h4 className="my-2">Subscription Cancelled</h4>
              </Card.Header>
              {loading ? (
                <Card.Body>
                  <LoadingState message="Loading subscription information..." />
                </Card.Body>
              ) : error ? (
                <Card.Body>
                  <ErrorState message={error} />
                </Card.Body>
              ) : (
                <Card.Body className="p-0">
                  <CancelState
                    title="Your subscription request has been cancelled"
                    message="You have not been charged and no changes have been made to your account. You will continue to have access to the features available in your current plan."
                  >
                    {subscription && subscription.status === 'active' && (
                      <Alert variant="info" className="mb-4">
                        You currently have an active Pro subscription. You will continue to have
                        access to all Pro features.
                      </Alert>
                    )}
                    
                    {(!subscription || subscription.status === 'free') && (
                      <Alert variant="secondary" className="mb-4">
                        You are currently on the Free plan. You can upgrade to Pro at any time
                        to access additional features.
                      </Alert>
                    )}
                    
                    <Button 
                      variant="primary" 
                      onClick={() => navigate('/dashboard')}
                      className="me-2 mb-2"
                    >
                      Back to Dashboard
                    </Button>
                    <Link to="/dashboard/subscription" className="btn btn-outline-primary mb-2">
                      View Subscription Options
                    </Link>
                  </CancelState>
                </Card.Body>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
  );
};

export default SubscriptionCancel;
